import { styled } from '@mui/system';
import { Box, Button } from '@mui/material';

export const AssociatedBox = styled(Box)(({ theme, sx }) => ({
    ...sx,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    width: '100%',
    minHeight: '80px',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    backgroundColor: '#E4E7EC',
    overflow: 'hidden',
    minWidth: '0',
    boxSizing: 'border-box'
}));
export const AddAssociatedButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '60px',
    backgroundColor: theme.palette.secondary.lighter
}));
export const AssociatedIconContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '60px',
    background: theme.palette.themeGradient.secondary,
    borderRadius: theme.shape.borderRadius
}));
